const config = {
  apiUrl: 'https://backend.poc.optiorx.com/users',
};

export default config;
// time stamp :_ 9:53pm IST